import InternalBadge from './Badge';
import Ribbon from './Ribbon';
const Badge = InternalBadge;
Badge.Ribbon = Ribbon;
export default Badge;
